import type { ComponentPropsWithoutRef } from "react";
import clsx from "clsx";

type PageWidth = "md" | "lg" | "xl" | "4xl" | "5xl" | "6xl" | "7xl";

const widthClassName: Record<PageWidth, string> = {
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
};

export type PageShellProps = ComponentPropsWithoutRef<"main"> & {
  width?: PageWidth;
};

const PageShell = ({ width = "6xl", className, children, ...props }: PageShellProps) => (
  <main
    className={clsx(
      "mx-auto w-full px-2 py-6 sm:px-6 sm:py-10 lg:py-12",
      widthClassName[width],
      className,
    )}
    {...props}
  >
    {children}
  </main>
);

export default PageShell;
